import { usePaywallContext } from '@frontend/react-domain';
import { Icon, XStack, useIsOnMobile } from '@frontend/web-react';

export const PaywallHeader = () => {
  const { paywallActions, paywallState } = usePaywallContext();
  const { handleBackButton } = paywallActions.navigation;
  const { onSkipPurchase } = paywallActions.purchase;
  const { showDismissButton } = paywallState.navigation;
  const isMobile = useIsOnMobile();

  const shouldShowBackButton =
    paywallState.navigation.canDecrement && paywallState.navigation.currentStep !== 'success';
  return (
    <XStack
      alignItems="center"
      className="border-b border-borderPrimary bg-trueWhite"
      flex={1}
      justifyContent="between"
      p={isMobile ? 'sm' : 'md'}
    >
      {/* Left section - always takes space */}
      <XStack alignItems="center" className="size-xl" justifyContent="start">
        {shouldShowBackButton ? <Icon name="IconArrowLeft" onClick={handleBackButton} size={24} /> : null}
      </XStack>

      {/* Center section - flexible */}
      <XStack className="flex-1" justifyContent="center">
        {/*<ProgressIndicator />*/}
      </XStack>

      {/* Right section - always takes space */}
      <XStack alignItems="center" className="size-xl" justifyContent="end">
        {showDismissButton ? <Icon name="IconX" onClick={onSkipPurchase} size={24} /> : null}
      </XStack>
    </XStack>
  );
};
